import { useContext, useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { GET_INSTALLER_EXPERTS_QUERY } from 'Queries/Queries';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import {
  DEB_CURRENT_TEST_SUITE,
  shouldFillDebTestData,
} from 'components/DEBForm/Utils/DebTestSetup';

export const useCurrentExperts = ({ skip = false, requireName = true } = {}) => {
  const { setShowError } = useContext(ErrorHandlingContext);
  const { data, loading, error, refetch } = useQuery(GET_INSTALLER_EXPERTS_QUERY, {
    skip,
  });

  const experts = useMemo(
    () =>
      shouldFillDebTestData
        ? DEB_CURRENT_TEST_SUITE.installerData.experts
        : data?.getInstallerExperts.filter((expert) => !requireName || expert.nachname) ?? null,
    [data, requireName]
  );

  useEffect(() => {
    if (error) {
      console.error('useCurrentExperts error:', error);
      setShowError((prev) => !prev && true); // Prevent multiple triggers
    }
  }, [error, setShowError]);

  return { experts, isLoading: loading, refetchExperts: refetch };
};
